// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { createFileRoute, useParams } from '@tanstack/react-router';

// api
import { useGatewaysGetAsyncByidQuery } from '@/api/generated/recalc/endpoints/v1/gateways';

// shared components
import PageContainer from '@/components/layout/PageContainer';
import PageHeader from '@/components/layout/PageHeader';
import GatewayLoadingIndicator from '@/components/ui/progress/GatewayLoadingIndicator';

// feature-components
import EditGatewayForm from '@/features/gateways/forms/EditGatewayForm';

import { skipToken } from '@reduxjs/toolkit/query';

export const Route = createFileRoute(
  '/$accountId/_user/gateways/$gatewayId/edit',
)({
  component: RouteComponent,
  staticData: { crumb: 'units-gateways-sensors:common.edit' },
});

function RouteComponent() {
  const { t } = useTranslation('units-gateways-sensors');
  const { gatewayId } = useParams({ strict: false });
  const numericGatewayId = gatewayId ? Number(gatewayId) : undefined;

  const {
    data: gateway,
    isLoading,
    refetch,
  } = useGatewaysGetAsyncByidQuery(
    numericGatewayId != null ? { id: numericGatewayId } : skipToken,
  );

  return (
    <PageContainer maxWidth="xl" sx={{ py: 2 }}>
      <GatewayLoadingIndicator isLoading={isLoading} />
      <PageHeader
        title={t('common:actions.editItem', { item: gateway?.Name ?? '' })}
      ></PageHeader>
      {gateway && (
        <EditGatewayForm
          key={gateway.GatewayId}
          gateway={gateway}
          refetchGateway={refetch}
        />
      )}
    </PageContainer>
  );
}
